export const messages = {
  en: {
    accountBondObjDetail: {
      queryCondition: 'Query Condition',
      selectShop: 'Please select shop',
      selectStatus: 'Please select status',
      payBond: 'Pay Bond',
      refundBond: 'Refund Bond',
      query: 'Query',
      bondDetail: 'Bond Detail',
      bondId: 'Bond ID',
      bondObj: 'Bond Object',
      receivableAmount: 'Receivable Amount',
      receivedAmount: 'Received Amount',
      status: 'Status',
      startTime: 'Start Time',
      endTime: 'End Time',
      bondDetails: 'Bond Details'
    }
  },
  zh: {
    accountBondObjDetail: {
      queryCondition: '查询条件',
      selectShop: '请选择商铺',
      selectStatus: '请选择状态',
      payBond: '交保证金',
      refundBond: '退保证金',
      query: '查询',
      bondDetail: '保证金明细',
      bondId: '保证金ID',
      bondObj: '保证金对象',
      receivableAmount: '应收金额',
      receivedAmount: '实收金额',
      status: '状态',
      startTime: '开始时间',
      endTime: '结束时间',
      bondDetails: '保证金明细'
    }
  }
}